import { connect } from 'react-redux';

import Actions from '../../Actions/Creators';
import Dashboard from './Component/Dashboard';


const mapStateToProps = (state, ownProps) => ({
    isAuthenticated: state.auth.isAuthenticated,
    user: state.auth.userProfile,
    
    childListLoaded: state.child.loaded,
    childListLoading: state.child.isLoading,
    childList: state.child.childList,
    selectedChild: state.child.selectedChild || 0,

    isLoadingReportStatus: state.child.isLoadingReportStatus,
    statusList: state.child.statusList,

    /*isLoadingReport: state.child.isLoadingReport,
    reportName: state.child.reportName,
    reportError: state.child.reportError,
    report: state.child.report,*/

    partnersList: state.metaData.partnersList,

    addChild: state.addChild,

    otpInfo: state.auth.userProfile && state.auth.userProfile.data && Boolean(state.auth.userProfile.data.custom.json_value) ? state.auth.userProfile.data.custom.json_value.OTP_info : null,
    verifyOtp: state.verifyOtp
});


const mapDispatchToProps = (dispatch) => ({
    fetchChildList: (userId, studentId) => dispatch(Actions.fetchChildList({ userId, studentId })),
    verifyCode: (code, dob) => dispatch(Actions.verifyAvailabilityCode(code, dob)),
    addChildUsingActivationCode: (params) => dispatch(Actions.addChildUsingActivationCode(params)),
    fetchStudentAssessmentStatus: (userId, eventTrackId) => dispatch(Actions.fetchStudentAssessmentStatus(userId, eventTrackId)),
    fetchPentahoReport: (reportName, studentId, startNodeId) => dispatch(Actions.fetchPentahoReport(reportName, studentId, startNodeId)),
    sendOtp: (username) => dispatch(Actions.sendOtpPhone(username)),
    handleVerifyOtp: (username, otp) => dispatch(Actions.verifyOtp(username, otp)),
    getUser: () => dispatch(Actions.getUser())
});


export default connect(mapStateToProps, mapDispatchToProps)(Dashboard)